import { computed, inject } from 'vue';
import { NodeType } from '@amplify/amp-module';
import { GetAddingNode } from '@/constants/getters';
import { AddNode, ClearAddingNode, UpdateNodeData } from '@/constants/actions';
import { hoverNode, initNodeData, initNodeId } from '@/utils/builder-utils';
import { useStoreInNodes } from '@/composables/useStoreInNodes';

export const useNodeActions = () => {
  const { store } = useStoreInNodes();

  const getGraph = inject('getGraph', () => {});

  const addingNode = computed(() => store.value.getters[`builderStore/${GetAddingNode}`]);

  const onDrop = (event, nodeId, subNodeId, side) => {
    const newNode = event.dataTransfer.getData('newNode');
    // const movedNode = _e.dataTransfer.getData('movedNode');

    if (newNode) {
      addNodeToStore(getGraph().getCellById(nodeId), getStoreNode(JSON.parse(newNode)), side, subNodeId);
    }
    // else if (movedNode) {
    //   // TODO: Scaffolding for Moving Nodes task
    // }
  };

  const addNodeOfType = (nodeId, nodeDetails, subNodeId) => {
    const { side } = nodeDetails;

    store.value.dispatch(`builderStore/${ClearAddingNode}`);

    addNodeToStore(getGraph().getCellById(nodeId), getStoreNode(nodeDetails), side, subNodeId);
  };

  const addNodeToStore = (parentGraphNode, newStoreNode, side, subNodeId) => {
    if (!parentGraphNode) {
      return;
    }

    hoverNode(parentGraphNode, false);

    newStoreNode = initNodeData(newStoreNode);

    if (side !== 'top') {
      if (subNodeId) {
        newStoreNode.parentId = `${parentGraphNode.id}_port_${subNodeId}`;
      } else if (parentGraphNode.id !== 'start-node') {
        newStoreNode.parentId = parentGraphNode.id;
      }
    } else {
      assignParentToTarget(parentGraphNode.id, newStoreNode);
    }

    store.value.dispatch(`builderStore/${AddNode}`, newStoreNode);
  };

  const assignParentToTarget = (id, newParent) => {
    let data = {};

    if ([NodeType.buttonGroup, NodeType.question].includes(newParent.type)) {
      const subNodes = Object.values(newParent.subNodes);

      data = { id, parentId: `${newParent.id}_port_${subNodes[0].id}` };
    } else {
      data = { id, parentId: newParent.id };
    }

    // Future Handling for adding Conditionals as parents
    // else if (newParent.type === NodeType.condition) {
    //   data = { id, parentId: `${newParent.id}_port_true` };
    // }

    store.value.dispatch(`builderStore/${UpdateNodeData}`, { data });
  };

  const getStoreNode = (nodeDetails) => {
    const { id, type, pluginId, settings } = nodeDetails;

    const storeNode = {
      id: id || initNodeId(type),
      type,
    };

    if (type === NodeType.plugin) {
      storeNode.pluginId = pluginId;
      storeNode.settings = settings;
    }

    return storeNode;
  };

  return {
    addingNode,
    addNodeOfType,
    onDrop,
  };
};
